import App from 'app/app.js';
import 'app/directive/GlobalMessagesCtrl.js';

function GlobalMessagesDirective() {
  return {
    restrict: 'E',
    scope: {
      data: '=',
      onSubmit: '&'
    },
    template:
      '<div class="row" >' +
      '  <div class="col-xs-12">' +
      '     <br /><ul class="global-messages" ng-repeat="item in getFormMessages() | filter:hasResult | limitTo: 1">' +
      '       <li class="error" lt-translate="MISSING_INVALID_INFORMATION"></li>' +
      '     </ul>' +
      '  </div>' +
      '</div>',
    controller: 'GlobalMessagesCtrl',
    controllerAs: 'globalMessages'
  };
}

App.directive('globalMessages', [GlobalMessagesDirective]);
